import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IArrowDownToolButtonProps extends IconButtonProps {
    tooltip?: string;
}

export const ArrowDownToolButton = (props: IArrowDownToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.MoveDown}
        icon={<ArrowDownwardIcon />}
    />
);
